export const moduleId = 'invoiceCollect'
import UserPersistence from '@/persistence/UserPersistence'
import NumberUtils from '../../libs/utils/NumberUtils'
import  api from '../../api/invoice-collect'
import {setMessage} from "../../libs/message";
import _ from '../../libs//utils/ObjectUtils'

const state = {
  drawer: false,
  invoiceList: [], //图片集合
  activeIndex: "",
  localCollectFlag:true, //本地上传 平台上传标识
  reimbursementType:'',//报账类型
  localUploadVisible: false,
  invoiceType: "", //票据类别 addedTax 增值税 airPlane 航空行程单   train 火车票 boats 车船票 loackPass 桥闸票  taxi//出租车票 // otherTraffic //其他交通 other 其他 //银行回单 back
  curInvoiceInfo: {}, //当前票据信息
  saveBtnActive: false, //保存按钮激活
  flag: 'add', //新增   和编辑
  resultVisible: false,//上传结果
  resultObj: {},
  addFlag:true,
  approve:false,   //显示上传按钮
  limitSize:5,
  invoiceTypeList:[]



}

const getters = {

}

const mutations = {
  setDrawer(state, data) {
    state.drawer = data
  },
  setInvoiceTypeList(state,data){
    state.invoiceTypeList = data
  },
  setLocalCollectFlag(state,data){
    state.localCollectFlag =data
  },
  setlimitSize(state,data){
    state.limitSize = data

  },
  emptyData(){
    state.curInvoiceInfo = {},
    state.activeIndex =""
    state.invoiceList = []
    state.invoiceType=""
  },
  setLocalUploadVisible(state, data) {
    state.localUploadVisible = data
  },
  setApprove(state,data){
    state.approve = data
    
  },
  setCurInvoiceInfo(state, data) {
    
   
    // 增值票
    if (state.invoiceType === 'addedTax') {
      let list = state.curInvoiceInfo.entity.goodsEntityList
      state.curInvoiceInfo.entity = { ...data, goodsEntityList: list }
      state.curInvoiceInfo.invoiceClass = data.invoiceClass

    }else if(state.invoiceType === 'train' ||state.invoiceType === 'airPlane'||state.invoiceType === 'loackPass' ||state.invoiceType === 'taxi'||state.invoiceType === 'otherTraffic' ||  state.invoiceType === 'other' || state.invoiceType === 'boats'  || state.invoiceType === 'back'){//火车票
        let groupdata = {...data}
        state.curInvoiceInfo.invoiceClass = data.invoiceClass
        delete groupdata.invoiceClass
      state.curInvoiceInfo.entity = { ...groupdata }
    }

   
  },
  setResultVisible(state, data) {
    state.resultVisible = data
    
    
  },

  changeInvoiceClass(state, value) {
    let invoiceClass = value + ""
    switch (invoiceClass) {
      case '139001':
        state.invoiceType="addedTax"
        break;
      case '139002':
        state.invoiceType="addedTax"
        break;
      case '139003':
        state.invoiceType="addedTax"
        break;
      case '139004':
        state.invoiceType="addedTax"
        break;
      case '139005':
        state.invoiceType="airPlane"
        break;
      case '139006':
        state.invoiceType="train"
        break;
      case '139007':
        state.invoiceType="boats"
        break;
      case '139008':
        state.invoiceType="loackPass"
        break;
      case '139009':
        state.invoiceType="taxi"
        break;
      case '139010':
        state.invoiceType ="otherTraffic"
        break;
      case '139011':
        state.invoiceType="other"
        break;
      case '139012':
        state.invoiceType="back"
        break;
    }
    state.curInvoiceInfo.invoiceClass = value
    
    state.curInvoiceInfo.entity = {}
    state.curInvoiceInfo.isSave = false   
    if(state.invoiceType == 'addedTax'){
      state.curInvoiceInfo.entity.goodsEntityList = [{ taxClassName: "",model:"", units:"",count:"",amount:"",taxRate:"",taxAmount:"",rowNum:0}]
      state.curInvoiceInfo.entity.ischangeInvoice = true
    }
  
  },
  setAddFlag(state,data){
    state.addFlag = data
  },

  setResultObj(state, data) {
    state.resultObj = data
   
  },
  //清空 或改变其中的某一项
  changeInvoiceList(state,data){
 
      state.invoiceList[state.activeIndex] = {...state.curInvoiceInfo}
  },

  setSaveBtnActive(state, data) {
    state.saveBtnActive = data

  },
  setActiveIndex(state, data) {

    state.activeIndex = data
  },

  steIsSave(state, data) {
    state.curInvoiceInfo.isSave = data;

  },
  //
  setBusinessType(state, data) {
    state.invoiceType = data

  },
  setInvoiceList(state, data) {
    if(data.length == 0) return false
    if (state.invoiceList.length == 0) {
      state.activeIndex = 0
    } else {
      state.activeIndex = state.invoiceList.length
    }
    let tableData = data.map((item) => {
      item.isSave = false;
      return {
        ...item,

      }
    })
    state.invoiceList = state.invoiceList.concat(tableData)
    //判断票据类别
    let invoiceTypeList = UserPersistence.getEnumerationList().filter(
      item => item.categoryId === "139"
    );
    let invoiceItem = invoiceTypeList.filter(
      item => item.id == state.invoiceList[state.activeIndex].invoiceClass
    );
   
    if (invoiceItem[0].name === '增值税普通发票' || invoiceItem[0].name === '增值税专用发票' || invoiceItem[0].name === '增值税电子普通发票' || invoiceItem[0].name === '增值税电子专用发票') {
      state.invoiceType = 'addedTax'
    }else if(invoiceItem[0].name === '航空行程单'){
      state.invoiceType = 'airPlane'

    }else if(invoiceItem[0].name === '火车票'){
      state.invoiceType = 'train'

    }else if(invoiceItem[0].name === '实名车船票'){
      state.invoiceType = 'boats'
    }else if(invoiceItem[0].name === '桥闸通行票'){
      state.invoiceType = 'loackPass'
    }else if(invoiceItem[0].name === '出租车票'){
      state.invoiceType = 'taxi'
    }else if(invoiceItem[0].name === '其他交通票'){
      state.invoiceType = 'otherTraffic'
    }else if(invoiceItem[0].name === '其他发票'){
      state.invoiceType = 'other'
    }else if(invoiceItem[0].name === '银行回单'){
      state.invoiceType = 'back'
    }
    state.curInvoiceInfo = _.cloneDeep(state.invoiceList[state.activeIndex])
  },
  //修改增值税发票表格信息
  changeTableData(state,data){
    state.curInvoiceInfo.entity.goodsEntityList  = data
    state.invoiceList[state.activeIndex].entity.goodsEntityList = data
  },
  //根据报账类型限制上传票据
  setReimbursementType(state,data){
    state.reimbursementType = data
  }
}

const actions = {
  async gteInvoiceDetail({ state, commit }, params) {
    console.log(params)
    
    let res = await api.getinvoice({ fileIds:[params.fileId] })
    if(res.code == 0 ){
      
       //查看
      if(params.type == 2){
        state.drawer = true
        state.invoiceList = params.list
         let index =  state.invoiceList.findIndex((item)=>item.fileId == params.fileId)
         state.invoiceList[index] = {...res.data}
         state.activeIndex  = index
        state.curInvoiceInfo = {...res.data}
          state.curInvoiceInfo.isSave = false;
          commit('setAddFlag',false)
          

      }else if(params.type == 1){
        state.curInvoiceInfo = {...res.data}
        state.curInvoiceInfo.isSave = false;
        state.activeIndex = params.index
        let  copyData = {...state.curInvoiceInfo}
        delete copyData.isSave
        state.invoiceList[state.activeIndex] = {...copyData}
      }
      let invoiceTypeList = UserPersistence.getEnumerationList().filter(
        item => item.categoryId === "139"
      );
      let invoiceItem = invoiceTypeList.filter(
        item => item.id == res.data.invoiceClass
      );
      if(invoiceItem.length>0){
        if (invoiceItem[0].name === '增值税普通发票' || invoiceItem[0].name === '增值税专用发票' || invoiceItem[0].name === '增值税电子普通发票' || invoiceItem[0].name === '增值税电子专用发票') {
          state.invoiceType = 'addedTax'
        }else if(invoiceItem[0].name === '航空行程单'){
          state.invoiceType = 'airPlane'
    
        }else if(invoiceItem[0].name === '火车票'){
          state.invoiceType = 'train'
    
        }else if(invoiceItem[0].name === '实名车船票'){
          state.invoiceType = 'boats'
        }else if(invoiceItem[0].name === '桥闸通行票'){
          state.invoiceType = 'loackPass'
        }else if(invoiceItem[0].name === '出租车票'){
          state.invoiceType = 'taxi'
        }else if(invoiceItem[0].name === '其他交通票'){
          state.invoiceType = 'otherTraffic'
        }else if(invoiceItem[0].name === '其他发票'){
          state.invoiceType = 'other'
        }else if(invoiceItem[0].name === '银行回单'){
          state.invoiceType = 'back'
        }
      
      }else{
        state.invoiceType = 'feeTicket'
      }
     
    }else{
      setMessage({
        message: res.msg,
        type: 'warning'
      });
    }
  
     
   
  }

}
let data = {
  moduleId,
  state,
  getters,
  mutations,
  actions

}

export default  [data]



// WEBPACK FOOTER //
// ./src/store/modules/invoiceCollect.js